// extracted by mini-css-extract-plugin
export var originalPrice = "_w3-0";